<template>
  <div>
    <Loader
      v-if="$apollo.loading && !errors.length"
      label="Loading Layout..."
    />

    <LayoutEditor
      v-if="!$apollo.loading && !errors.length"
      :key="sectionsCount"
      :campaign="campaign"
      :settings-active="settingsActive"
      @update:settings-active="settingsActive = $event"
    />

    <transition name="fade" :duration="{ enter: 1000, leave: 1000 }">
      <div v-if="!$apollo.loading && !settingsActive" class="px-4">
        <SidebarMeta>
          <template #primary>
            <Button class="sm secondary ml-auto" @click="onNewSectionClick">
              Add New Section
            </Button>
          </template>
        </SidebarMeta>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/UI/Loader";
import LayoutEditor from "@/components/Editor/Layout/LayoutEditor";
import SidebarMeta from "@/components/Editor/Sidebar/SidebarMeta";

export default {
  name: "Layout",
  components: { LayoutEditor, Loader, SidebarMeta },
  props: {
    campaign: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    errors: [],
    settingsActive: false,
  }),
  computed: {
    sectionsCount() {
      const sections = this.campaign?.template?.sections ?? [];

      return sections.length;
    },
  },
  methods: {
    onNewSectionClick() {
      this.$modal.show("widgets", {
        campaignId: this.campaign.campaignId,
      });
    },
  },
};
</script>

<style scoped></style>
